export default __webpack_public_path__ + "static/media/nature-ge9be872df_1920.ab6ae780.jpg";